import axios from 'axios';
import config from '../../config/config';

// Define your base URL and headers
const baseURL = config.apiUrl;
const headers = {
  "Accept": "application/json",
  "Content-Type": "application/json",
  //"Referrer-Policy": "http://localhost"
};

const headers2 = {
  "Accept": "*",
  "Content-Type": "application/x-www-form-urlencoded"
};

// Create an Axios instance with predefined settings
const apiService = axios.create({
  baseURL,
  headers,
});

const apiService2 = axios.create({
  baseURL,
  headers2,
});

// Define a function to wrap axios.post
const apiServicePost = (url, data) => apiService.post(url, data);

// TEST 
const apiServicePostBuyTicket = (url, data) => apiService2.post(url, data);

// Export the wrapped function
export { apiServicePost, apiServicePostBuyTicket };

